import { Link, useLoaderData } from "react-router-dom";
import * as API from "../services/audit";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAuditByID(params.auditId);
}

export function AuditItem(props) {
  const audit = useLoaderData();
  const errorMessage = audit.message;

  const auditResp = audit.meta?.auditResp;
  const metaFecha = audit.meta?.metaFecha;
  const auditFrecalcoh = audit.meta?.auditFrecalcoh;
  const auditCuantbeb = audit.meta?.auditCuantbeb;
  const auditFrecdia = audit.meta?.auditFrecdia;
  const auditParar = audit.meta?.auditParar;
  const auditHacer = audit.meta?.auditHacer;
  const auditNeces = audit.meta?.auditNeces;
  const auditRemord = audit.meta?.auditRemord;
  const auditRecor = audit.meta?.auditRecor;
  const auditHerid = audit.meta?.auditHerid;
  const auditPreoc = audit.meta?.auditPreoc;

  const auditDate = new Date(audit.date);
  const diffDate = (Math.abs(new Date() - auditDate) / 36e5);

  console.log(
    auditResp,
    metaFecha,
    auditFrecalcoh,
    auditCuantbeb,
    auditFrecdia,
    auditParar,
    auditHacer,
    auditNeces,
    auditRemord,
    auditRecor,
    auditHerid,
    auditPreoc
  );

  return (
    <>
      <div id='content'>
        {audit.length === 0 ? (
          <div>Cargando...</div>
        ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement' className='newRadioButtons'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='auditResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='auditResp'
                      required
                      type='text'
                      value={auditResp}
                      readOnly
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='metaFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='metaFecha'
                      required
                      type='date'
                      value={metaFecha}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <h3>Cuestionario A.U.D.I.T.</h3>
              <div className='form-radio-container'>
                <div className='grid--2-col'>
                  <div className='radio-capt radio--5-col'>
                    <p>Nunca</p>
                    <p>Mensualmente o menos</p>
                    <p>2 a 4 veces al mes</p>
                    <p>2 o 3 veces a la semana</p>
                    <p>4 o más veces a la semana</p>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='auditFrecalcoh'>
                      1. ¿Con qué frecuencia se toma alguna bebida que contenga
                      alcohol?
                    </label>
                    <div className='radio--5-col'>
                      <label className='radio' htmlFor='auditFrecalcoh-0'>
                        <input
                          id='auditFrecalcoh-0'
                          name='auditFrecalcoh'
                          type='radio'
                          value='0'
                          checked={auditFrecalcoh === "0"}
                          readOnly
                        />
                        0
                      </label>
                      <label className='radio' htmlFor='auditFrecalcoh-1'>
                        <input
                          id='auditFrecalcoh-1'
                          name='auditFrecalcoh'
                          type='radio'
                          value='1'
                          checked={auditFrecalcoh === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='auditFrecalcoh-2'>
                        <input
                          id='auditFrecalcoh-2'
                          name='auditFrecalcoh'
                          type='radio'
                          value='2'
                          checked={auditFrecalcoh === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='auditFrecalcoh-3'>
                        <input
                          id='auditFrecalcoh-3'
                          name='auditFrecalcoh'
                          type='radio'
                          value='3'
                          checked={auditFrecalcoh === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='auditFrecalcoh-4'>
                        <input
                          id='auditFrecalcoh-4'
                          name='auditFrecalcoh'
                          type='radio'
                          value='4'
                          checked={auditFrecalcoh === "4"}
                          readOnly
                        />
                        4
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className='form-radio-container'>
                <div className='grid--2-col'>
                  <div className='radio-capt radio--5-col'>
                    <p>1 ó 2</p>
                    <p>3 ó 4</p>
                    <p>5 ó 6</p>
                    <p>7 a 9</p>
                    <p>10 o más</p>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='auditCuantbeb'>
                      2. ¿Cuántas bebidas alcohólicas toma en un día normal
                      cuando bebe?
                    </label>
                    <div className='radio--5-col'>
                      <label className='radio' htmlFor='auditCuantbeb-0'>
                        <input
                          id='auditCuantbeb-0'
                          name='auditCuantbeb'
                          type='radio'
                          value='0'
                          checked={auditCuantbeb === "0"}
                          readOnly
                        />
                        0
                      </label>
                      <label className='radio' htmlFor='auditCuantbeb-1'>
                        <input
                          id='auditCuantbeb-1'
                          name='auditCuantbeb'
                          type='radio'
                          value='1'
                          checked={auditCuantbeb === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='auditCuantbeb-2'>
                        <input
                          id='auditCuantbeb-2'
                          name='auditCuantbeb'
                          type='radio'
                          value='2'
                          checked={auditCuantbeb === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='auditCuantbeb-3'>
                        <input
                          id='auditCuantbeb-3'
                          name='auditCuantbeb'
                          type='radio'
                          value='3'
                          checked={auditCuantbeb === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='auditCuantbeb-4'>
                        <input
                          id='auditCuantbeb-4'
                          name='auditCuantbeb'
                          type='radio'
                          value='4'
                          checked={auditCuantbeb === "4"}
                          readOnly
                        />
                        4
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className='form-radio-container'>
                <div className='grid--2-col'>
                  <div className='radio-capt radio--5-col'>
                    <p>Nunca</p>
                    <p>Menos que mensualmente</p>
                    <p>Mensualmente</p>
                    <p>Semanalmente</p>
                    <p>A diario o casi diario</p>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='auditFrecdia'>
                      3. ¿Con qué frecuencia se toma 6 o más bebidas que
                      contengan alcohol en una ocasión?
                    </label>
                    <div className='radio--5-col'>
                      <label className='radio' htmlFor='auditFrecdia-0'>
                        <input
                          id='auditFrecdia-0'
                          name='auditFrecdia'
                          type='radio'
                          value='0'
                          checked={auditFrecdia === "0"}
                          readOnly
                        />
                        0
                      </label>
                      <label className='radio' htmlFor='auditFrecdia-1'>
                        <input
                          id='auditFrecdia-1'
                          name='auditFrecdia'
                          type='radio'
                          value='1'
                          checked={auditFrecdia === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='auditFrecdia-2'>
                        <input
                          id='auditFrecdia-2'
                          name='auditFrecdia'
                          type='radio'
                          value='2'
                          checked={auditFrecdia === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='auditFrecdia-3'>
                        <input
                          id='auditFrecdia-3'
                          name='auditFrecdia'
                          type='radio'
                          value='3'
                          checked={auditFrecdia === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='auditFrecdia-4'>
                        <input
                          id='auditFrecdia-4'
                          name='auditFrecdia'
                          type='radio'
                          value='4'
                          checked={auditFrecdia === "4"}
                          readOnly
                        />
                        4
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='auditParar'>
                      4. ¿Con qué frecuencia en el último año ha sido incapaz de
                      parar de beber una vez había empezado?
                    </label>
                    <div className='radio--5-col'>
                      <label className='radio' htmlFor='auditParar-0'>
                        <input
                          id='auditParar-0'
                          name='auditParar'
                          type='radio'
                          value='0'
                          checked={auditParar === "0"}
                          readOnly
                        />
                        0
                      </label>
                      <label className='radio' htmlFor='auditParar-1'>
                        <input
                          id='auditParar-1'
                          name='auditParar'
                          type='radio'
                          value='1'
                          checked={auditParar === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='auditParar-2'>
                        <input
                          id='auditParar-2'
                          name='auditParar'
                          type='radio'
                          value='2'
                          checked={auditParar === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='auditParar-3'>
                        <input
                          id='auditParar-3'
                          name='auditParar'
                          type='radio'
                          value='3'
                          checked={auditParar === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='auditParar-4'>
                        <input
                          id='auditParar-4'
                          name='auditParar'
                          type='radio'
                          value='4'
                          checked={auditParar === "4"}
                          readOnly
                        />
                        4
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='auditHacer'>
                      5. ¿Con qué frecuencia en el último año no pudo hacer lo
                      que se esperaba de usted como consecuencia de la bebida?
                    </label>
                    <div className='radio--5-col'>
                      <label className='radio' htmlFor='auditHacer-0'>
                        <input
                          id='auditHacer-0'
                          name='auditHacer'
                          type='radio'
                          value='0'
                          checked={auditHacer === "0"}
                          readOnly
                        />
                        0
                      </label>
                      <label className='radio' htmlFor='auditHacer-1'>
                        <input
                          id='auditHacer-1'
                          name='auditHacer'
                          type='radio'
                          value='1'
                          checked={auditHacer === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='auditHacer-2'>
                        <input
                          id='auditHacer-2'
                          name='auditHacer'
                          type='radio'
                          value='2'
                          checked={auditHacer === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='auditHacer-3'>
                        <input
                          id='auditHacer-3'
                          name='auditHacer'
                          type='radio'
                          value='3'
                          checked={auditHacer === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='auditHacer-4'>
                        <input
                          id='auditHacer-4'
                          name='auditHacer'
                          type='radio'
                          value='4'
                          checked={auditHacer === "4"}
                          readOnly
                        />
                        4
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='auditNeces'>
                      6. ¿Con qué frecuencia en el último año ha necesitado
                      beber por la mañana para recuperarse después de haber
                      bebido mucho el día anterior?
                    </label>
                    <div className='radio--5-col'>
                      <label className='radio' htmlFor='auditNeces-0'>
                        <input
                          id='auditNeces-0'
                          name='auditNeces'
                          type='radio'
                          value='0'
                          checked={auditNeces === "0"}
                          readOnly
                        />
                        0
                      </label>
                      <label className='radio' htmlFor='auditNeces-1'>
                        <input
                          id='auditNeces-1'
                          name='auditNeces'
                          type='radio'
                          value='1'
                          checked={auditNeces === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='auditNeces-2'>
                        <input
                          id='auditNeces-2'
                          name='auditNeces'
                          type='radio'
                          value='2'
                          checked={auditNeces === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='auditNeces-3'>
                        <input
                          id='auditNeces-3'
                          name='auditNeces'
                          type='radio'
                          value='3'
                          checked={auditNeces === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='auditNeces-4'>
                        <input
                          id='auditNeces-4'
                          name='auditNeces'
                          type='radio'
                          value='4'
                          checked={auditNeces === "4"}
                          readOnly
                        />
                        4
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='auditRemord'>
                      7. ¿Con qué frecuencia en el último año ha tenido
                      remordimientos o sentimientos de culpa después de haber
                      bebido?
                    </label>
                    <div className='radio--5-col'>
                      <label className='radio' htmlFor='auditRemord-0'>
                        <input
                          id='auditRemord-0'
                          name='auditRemord'
                          type='radio'
                          value='0'
                          checked={auditRemord === "0"}
                          readOnly
                        />
                        0
                      </label>
                      <label className='radio' htmlFor='auditRemord-1'>
                        <input
                          id='auditRemord-1'
                          name='auditRemord'
                          type='radio'
                          value='1'
                          checked={auditRemord === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='auditRemord-2'>
                        <input
                          id='auditRemord-2'
                          name='auditRemord'
                          type='radio'
                          value='2'
                          checked={auditRemord === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='auditRemord-3'>
                        <input
                          id='auditRemord-3'
                          name='auditRemord'
                          type='radio'
                          value='3'
                          checked={auditRemord === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='auditRemord-4'>
                        <input
                          id='auditRemord-4'
                          name='auditRemord'
                          type='radio'
                          value='4'
                          checked={auditRemord === "4"}
                          readOnly
                        />
                        4
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='auditRecor'>
                      8. ¿Con qué frecuencia en el último año no ha podido
                      recordar lo que sucedió la noche anterior porque había
                      estado bebiendo?
                    </label>
                    <div className='radio--5-col'>
                      <label className='radio' htmlFor='auditRecor-0'>
                        <input
                          id='auditRecor-0'
                          name='auditRecor'
                          type='radio'
                          value='0'
                          checked={auditRecor === "0"}
                          readOnly
                        />
                        0
                      </label>
                      <label className='radio' htmlFor='auditRecor-1'>
                        <input
                          id='auditRecor-1'
                          name='auditRecor'
                          type='radio'
                          value='1'
                          checked={auditRecor === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='auditRecor-2'>
                        <input
                          id='auditRecor-2'
                          name='auditRecor'
                          type='radio'
                          value='2'
                          checked={auditRecor === "2"}
                          readOnly
                        />
                        2
                      </label>
                      <label className='radio' htmlFor='auditRecor-3'>
                        <input
                          id='auditRecor-3'
                          name='auditRecor'
                          type='radio'
                          value='3'
                          checked={auditRecor === "3"}
                          readOnly
                        />
                        3
                      </label>
                      <label className='radio' htmlFor='auditRecor-4'>
                        <input
                          id='auditRecor-4'
                          name='auditRecor'
                          type='radio'
                          value='4'
                          checked={auditRecor === "4"}
                          readOnly
                        />
                        4
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className='form-radio-container'>
                <div className='grid--2-col'>
                  <div className='radio-capt radio--3-col'>
                    <p>No</p>
                    <p>Sí, pero no en el último año</p>
                    <p>Sí, en el último año</p>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='auditHerid'>
                      9. Usted o alguna otra persona ¿han resultado heridos como
                      consecuencia de su consumo de alcohol?
                    </label>
                    <div className='radio--3-col'>
                      <label className='radio' htmlFor='auditHerid-0'>
                        <input
                          id='auditHerid-0'
                          name='auditHerid'
                          type='radio'
                          value='0'
                          checked={auditHerid === "0"}
                          readOnly
                        />
                        0
                      </label>
                      <label className='radio' htmlFor='auditHerid-1'>
                        <input
                          id='auditHerid-1'
                          name='auditHerid'
                          type='radio'
                          value='1'
                          checked={auditHerid === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='auditHerid-2'>
                        <input
                          id='auditHerid-2'
                          name='auditHerid'
                          type='radio'
                          value='2'
                          checked={auditHerid === "2"}
                          readOnly
                        />
                        2
                      </label>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <div className='control grid--2col'>
                    <label className='radio-title' htmlFor='auditPreoc'>
                      10. ¿Algún familiar, amigo, médico o profesional sanitario
                      han mostrado preocupación por su consumo de alcohol o le
                      han sugerido que reduzca su consumo?
                    </label>
                    <div className='radio--3-col'>
                      <label className='radio' htmlFor='auditPreoc-0'>
                        <input
                          id='auditPreoc-0'
                          name='auditPreoc'
                          type='radio'
                          value='0'
                          checked={auditPreoc === "0"}
                          readOnly
                        />
                        0
                      </label>
                      <label className='radio' htmlFor='auditPreoc-1'>
                        <input
                          id='auditPreoc-1'
                          name='auditPreoc'
                          type='radio'
                          value='1'
                          checked={auditPreoc === "1"}
                          readOnly
                        />
                        1
                      </label>
                      <label className='radio' htmlFor='auditPreoc-2'>
                        <input
                          id='auditPreoc-2'
                          name='auditPreoc'
                          type='radio'
                          value='2'
                          checked={auditPreoc === "2"}
                          readOnly
                        />
                        2
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72) || (props.userRole.includes('administrador')))  &&
        <Link className='button is-link' to={`edit`}>
          Editar
        </Link>
      }
      </div>
      }
    </>
  );
}
